export default "__VITE_ASSET__Des6msEg__"